var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"playref",staticClass:"tc-player"},[_c('video',{attrs:{"id":_vm.id,"preload":"auto","playsinline":"","webkit-playsinline":""}}),(_vm.playingError)?_c('img',{staticClass:"cover",attrs:{"src":_vm.cover}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }